export default __webpack_public_path__ + "f7e86d1116d11e9ff840a58ab1d35f79.png";